<template>
  <div class="mnp-data-select-provider" :class="[this.wrapperClass, {'embedded': this.embedded}]">
    <SimonModal
      :is-visible="showBrandSearchInfoModal"
      @hide="showBrandSearchInfoModal = false"
      id="brand-info-modal"
      :area-label-modal="getSlotText('areaLabelBrandSearchModal', 'Weitere Informationen')"
    >
      <slot name="txtProviderBrandInfo"></slot>
    </SimonModal>
    <SimonModal
      :is-visible="showNetworkInfoModal"
      @hide="showNetworkInfoModal = false"
      id="network-info-modal"
    >
      <slot name="txtProviderNetworkInfo"></slot>
    </SimonModal>
    <div class="provider-list-loading"
         v-if="storedMNProvidersLoadedStatus === '' || storedMNProvidersLoadedStatus === 'LOADING'">
      <div class="loader" :class="[{'small': this.embedded}]">
        <div></div>
        <div></div>
      </div>
    </div>
    <div v-if="storedMNProvidersLoadedStatus === 'LOADED'">
      <b-form-group class="brand-search-field mandatory no-valid-check-sign"
                    :class="['fieldset-selectProvider', vflowGetFeedbackClasses('inputBrandName', 'found')]">
        <b-row>
          <b-col :class="['pr-0']">
            <div class="fieldset--label" v-if="!this.embedded">
              <label id="labelForProviderInput" for="selectProvider"><span><slot name="lblProviderSelect"></slot></span>
              </label>
              <button type="button" aria-live="off" aria-haspopup="dialog" :aria-label="getSlotText('accessibilityInfoIconAlt')" class="icon-only" @click.prevent.stop="trackAndShowBrandSearchInfoModal()">
                 <img src="files/flash/images/svg-icons/info-icon.svg">
               </button>
            </div>
            <div class="dropdown-wrapper" @scroll="grabScrollEvent">
              <div class="dropdown" :ref="'dropdown' + $vnode.key">
                <div :id="$vnode.key" class="dropdown-border">
                  <input
                    role="combobox"
                    :aria-live="ariaLiveForInput"
                    :aria-label="ariaLabelForInput"
                    :aria-expanded="searchingBrand ? 'true' : 'false'"
                    aria-autocomplete="both"
                    aria-haspopup="listbox"
                    aria-controls="serviceProviders"
                    id="selectProvider"
                    ref="brandsearchinput"
                    class="form-control"
                    :class="[this.searchingBrand ? 'option-list-active' : '', (inputBrandName !== '' && inputBrandName !== null && this.searchingBrand ? 'clearable' : '')]"
                    type="text"
                    name="search"
                    spellcheck="false"
                    :value="inputBrandName"
                    :placeholder="placeholderForInput"
                    autocomplete="off"
                    @focus="onFocusSelectField(); vflowInputFocused('inputBrandName'); vflowInputFocused('selectedNetwork_')"
                    @keydown="onArrowKeyScroll"
                    @keydown.enter.prevent="onSelectByReturnKey(); vflowInputFocused('selectedNetwork_')"
                    @keydown.esc="exitSearchMode"
                    @input="inputBrandName = $event.target.value; reactOnUserInput(); vflowInputFocused('selectedNetwork_')"
                    @blur="isNavigatingInProviders = false; isUserTyping = false"
                  >
                </div>
                <button :aria-label="this.$slots.buttonClearProviderAltText[0].text" tabindex="0" id="brand-search-clear-input" class="clear-input" v-if="inputBrandName !== '' && inputBrandName !== null && searchingBrand" @click.prevent="clearSelection" @keydown.esc="exitSearchMode"></button>
                <!-- Screenreader live region for no results -->
                <div class="option-list-wrapper">
                  <div aria-live="polite" aria-atomic="true" class="sr-only" ref="liveRegion"></div>
                  <div aria-live="assertive" aria-atomic="true" class="sr-only">
                    {{ focus > -1 ? getProviderOptionAriaLabel(filteredSortedFlaggedBrandSelectOptions()[focus]) : '' }}
                  </div>
                  <ul :aria-busy="storedMNProvidersLoadedStatus === 'LOADED' ? 'false' : 'true'" role="listbox"
                      id="serviceProviders" :key="componentKey" ref="dropdownListContainer" tabindex="-1"
                      v-if="this.searchingBrand"
                      class="option-list" :class="[showPrice ? 'with-price' : '']" @scroll="scrollHandlerOnScroll">
                    <li aria-disabled="true" aria-hidden="true" role="option" id="item-0" class="no-item-found"
                        v-if="!this.filteredSortedFlaggedBrandSelectOptions() || this.filteredSortedFlaggedBrandSelectOptions().length == 0">
                      <slot name="txtInvalidPhoneNumberError">Keine Ergebnisse</slot>
                    </li>
                    <li v-for="(brand, index) in this.filteredSortedFlaggedBrandSelectOptions()"
                        :class="[{ focus: index === focus }, brand.frequency, { last: findLastHighBrand(brand) }]"
                        :key="brand.brandName"
                        @mouseover.prevent="listItemMouseOver(index)"
                        @mouseleave.prevent="listItemMouseLeave(index)"
                        @click="itemSelection(brand.brandName)"
                        role="option"
                        :id="'item-' + index"
                    >
                      <div class="item-wrapper" :aria-label="getProviderOptionAriaLabel(brand)">
                        <div class="name">{{ brand.brandName }}<span class="matching-provider-code"
                                                                     v-if="!brand.matchByBrandName && brand.matchedByCode !== null">{{
                            brand.matchedByCode
                          }}</span></div>
                        <div v-if="showPrice && hasTariffPromoPrice(brand)" class="price promo">
                          <span class="stroked-price">{{ formattedPriceWithOption(brand) }}</span>
                          <span class="promoted-price">{{ formattedPromoPriceWithOption(brand) }}</span>
                        </div>
                        <div v-else-if="showPrice" class="price">{{ formattedPriceWithOption(brand) }}</div>
                        <div v-else class="price">{{ formattedPriceWithOption(brand) }}</div>
                      </div>
                    </li>
                  </ul>
                  <div ref="scrollHandle" class="scroll-handle" v-if="this.searchingBrand"
                       @mousedown="scrollHandlerOnDragStart"></div>
                </div>
              </div>
            </div>
            <b-form-invalid-feedback v-if="vflowHasFailedRequired('inputBrandName') || unportableFound_">
              <slot v-if="unportableFound_" name="txtUnportableProviderError"></slot>
              <slot v-else name="txtInvalidRequiredError">Dies ist ein Pflichtfeld.</slot>
            </b-form-invalid-feedback>
          </b-col>
        </b-row>
      </b-form-group>

        <span class="sr-only" v-if="isProviderWithPriceVisible" ref="srProviderWithPrice" :tabindex="-1" aria-live="polite">{{ selectedBrandNameWithPrice }}</span>

      <CommonBrands
        v-if="!this.embedded && (this.searchingBrand || !this.validBrandSelected || this.unportableFound_)"
        @selected="takeCommonlyBrandSelection"
      >
        <template v-for="slot in possibleChildSlotsFor('Common')" v-slot:[`${slot.child}`]>
          <slot :name="`${slot.parent}`"></slot>
        </template>
      </CommonBrands>

      <b-form-group class="network-select mandatory radio-group"
                    v-if="!this.embedded && (!this.searchingBrand && this.withNetworkSelect && this.validBrandSelected && this.couldUseNetworkAsQualifier)"
                    :class="['fieldset-network', vflowGetFeedbackClasses('selectedNetwork_', 'found')]">
        <div class="fieldset--label">
          <label><span><slot name="lblProviderCurrentNetwork"></slot></span></label>
          <button type="button" aria-live="off" aria-haspopup="dialog" :aria-label="getSlotText('accessibilityInfoIconAlt')" class="icon-only" @click="showNetworkInfoModal = true">
            <img src="files/flash/images/svg-icons/info-icon.svg">
          </button>
        </div>
        <b-form-radio-group v-model="selectedNetwork_" @input="tryToDetermineProvider();" class="d-sm-none pr-0">
          <b-form-radio
            class="network-select-item"
            v-for="network in this.selectableNetworks" v-bind:key="network" :value="network"
            @click="vflowInputFocused('selectedNetwork_')"
          >{{ networkNames[network] ? networkNames[network] : network }}
          </b-form-radio>
        </b-form-radio-group>
        <div class="d-none d-sm-block text-center pr-0">
          <div class="switcher" :class="[selectedNetwork_ !== '' ? 'selected' : '']">
            <div class="switcher-item" :class="[selectedNetwork_ == network? 'selected' : '']"
                 @click="selectedNetwork_ = network" v-for="network in this.selectableNetworks" v-bind:key="network"
                 :value="network">
              {{ networkNames[network] ? networkNames[network] : network }}
            </div>
          </div>
        </div>

        <b-form-invalid-feedback v-if="!$v.selectedNetwork_.found">
          <slot name="txtCurrentNetworkRequiredError"></slot>
        </b-form-invalid-feedback>
      </b-form-group>
    </div>
  </div>
</template>

<script>
import syncProperty from '@/mixins/syncProperty'
import CommonBrands from '@/components/checkout/mnpData/CommonBrands.vue'
import { BCol, BFormGroup, BFormInvalidFeedback, BRow } from 'bootstrap-vue'
import { validationMixin } from 'vuelidate'
import isValid from '@/mixins/validators/isValid'
import { required } from 'vuelidate/lib/validators'
import validationFlow from '@/mixins/validators/validationFlow'
import useFeature from '@/mixins/useFeature'
import price from '@/mixins/formatters/price'
import SimonModal from '@/components/modal/SimonModal.vue'

export default {
  name: 'ProviderSelect',
  data () {
    return {
      isProviderWithPriceVisible: false,
      isNavigatingInProviders: false,
      isUserTyping: false,
      componentKey: 0,
      initialized: false,
      searchingBrand: false,
      focus: 0,
      showNetworkInfoModal: false,
      showBrandSearchInfoModal: false,
      determinedProvider: null,
      inputBrandName: '',
      selectedBrandName: '',
      lastInputBeforeApplied: '',
      lastFocusedBrand: '',
      blurredFields: {
        inputBrandName: false,
        selectedNetwork_: false
      },
      liveFeedbackFor: {
        inputBrandName: false,
        selectedNetwork_: false
      },
      mnpOnlyBrandNameReplacements: [],
      networkNames: {
        D1: 'Telekom (D1)',
        D2: 'Vodafone (D2)',
        O2: 'Telefónica (E-Netz)',
        E1: 'Telefónica (E-Netz)'
      },
      scrollHandlerDragging: false,
      scrollHandlerDragStartPos: 0,
      scrollHandlerDragLastPageY: 0,
      doTracking: true,
      brandPromotions: null,
      unportableErrorMsg: '',
      liveToggleChar: true,
      filteredProviderList: [],
      noResults: false
    }
  },
  props: {
    process: {
      type: String,
      default: 'ordering'
    },
    embedded: {
      type: Boolean,
      default: false
    },
    withNetworkSelect: {
      type: Boolean,
      default: true
    },
    wrapperClass: {
      type: String,
      default: ''
    },
    preselectProvider: {
      type: String,
      default: ''
    },
    frontendContext: {
      type: String,
      default: 'checkout'
    },
    quickSelectionBrand: {
      type: String,
      default: ''
    },
    mnpProvidersWithTariffs: {
      type: Array,
      default: () => []
    }
  },
  mixins: [
    validationMixin,
    isValid,
    syncProperty('active', 'active_'),
    syncProperty('brandName', 'selectedBrandName_'),
    syncProperty('network', 'selectedNetwork_'),
    syncProperty('providerKey', 'providerKey_'),
    syncProperty('providerCode', 'providerCode_'),
    syncProperty('providerNetwork', 'providerNetwork_'),
    syncProperty('relatedTariff', 'relatedTariff_'),
    syncProperty('unportableFound', 'unportableFound_'),
    syncProperty('unportableSelected', 'unportableSelected_'),
    syncProperty('invalid', 'invalid_'),
    syncProperty('forceLiveFeedback', 'forceLiveFeedback_'),
    useFeature('showFeaturePromotion'),
    useFeature('showFeaturePromotionProviderOnly'),
    useFeature('featurePromo2343'),
    validationFlow,
    price
  ],
  components: {
    SimonModal,
    BFormGroup,
    CommonBrands,
    BRow,
    BCol,
    BFormInvalidFeedback
  },
  watch: {
    '$v.$invalid': function (v) {
      this.invalid_ = v
      this.$emit('update:mnpin-provider-select-validation', v)
    },
    unportableFound_: async function (newValue) {
      if (newValue) {
        this.setProvider({ unportable: true })
        this.errorToast(this.unportableErrorMsg)
      } else {
        this.$emit('clearErrorToast')
      }
    },
    inputBrandName: function (val, oldVal) {
      // hide provider input as long as the user select from common brands and set focus manually
      if (val !== oldVal) {
        this.$refs.srProviderWithPrice?.focus()
      }
    },
    filteredProviderList (newVal) {
      if (!newVal || newVal.length === 0) {
        this.noResults = true
        this.announceToScreenReader(this.getSlotText('txtInvalidPhoneNumberError', 'Keine Ergebnisse'))
      }
    }
  },
  created () {
    document.addEventListener('click', this.documentClick)
    document.addEventListener('focusout', this.focusChanged)
    this.initialize()
    if (this.storedMNProvidersLoadedStatus === 'ERROR' || this.storedMNProvidersLoadedStatus === 'INVALID') {
      const data = {
        type: 'technical',
        message: 'Technischer Fehler beim Laden der Providerdaten'
      }
      if (typeof window.trackingNS?.track?.tracking === 'function') {
        window.trackingNS.track.tracking('error', data)
      }
    }
  },
  mounted () {
    if (this.preselectProvider && this.isExistingBrand(this.preselectProvider)) {
      this.selectedBrandName_ = this.preselectProvider
    }

    this.inputBrandName = this.selectedBrandName_
    this.itemSelection(this.selectedBrandName_)

    this.$v.$touch()
    this.invalid_ = this.$v.$invalid

    this.initialized = true

    this.showErrorMsg()
    this.getUnportableErrorMsg()

    if (this.isLoadingProvidersError) {
      this.errorToast(this.getSlotText('txtLoadingProvidersError', '(Fehler: 500)'))
    }
  },
  methods: {
    getProviderListLength () {
      this.filteredProviderList = this.filteredBrandSelectOptions()
    },
    announceToScreenReader (message) {
      const region = this.$refs.liveRegion
      if (!region) return
      // Trick Screenreader into reading the message again.
      const toggleChar = this.liveToggleChar ? '\u200B' : '\u200C'
      region.textContent = message + toggleChar

      this.liveToggleChar = !this.liveToggleChar
    },
    exitSearchMode () {
      this.searchingBrand = false
      this.$refs.brandsearchinput.blur()
    },
    getProviderOptionAriaLabel (brand) {
      let label = brand.brandName

      // Add promo price if available
      if (this.showPrice && this.hasTariffPromoPrice(brand)) {
        label += `, Preis ${this.formattedPromoPriceWithOption(brand)}`
      } else if (this.showPrice) {
        // Add regular price
        label += `, Preis ${this.formattedPriceWithOption(brand)}`
      }

      return label
    },
    getUnportableErrorMsg () {
      this.unportableErrorMsg = this.getSlotText('txtUnportableProviderToastError', 'txtUnportableProviderToastError')
    },
    getProviderList () {
      this.$store.dispatch(`checkoutv2/${this.process}/_mnpData/getProviderList`)
    },
    async initialize () {
      await this.getProviderList()
    },
    setProvider (provider) {
      this.$store.commit(`checkoutv2/${this.process}/_mnpData/setProvider`, provider)
    },
    showErrorMsg () {
      if (!this.embedded && (this.storedMNProvidersLoadedStatus === 'ERROR' || this.storedMNProvidersLoadedStatus === 'INVALID')) {
        this.errorToast(this.getSlotText('txtErrorLoadingProviderList', '(Fehler: 500)'))
      }
    },
    resetAll () {
      this.resetInputField()
    },
    resetInputField () {
      this.inputBrandName = ''
      this.resetProviderSelection()
    },
    resetProviderSelection () {
      this.providerKey_ = ''
      this.providerCode_ = ''
      this.providerNetwork_ = ''
      this.relatedTariff_ = null
      this.unportableFound_ = false
      this.unportableSelected_ = false
      this.selectedNetwork_ = ''
      this.selectedBrandName = ''
      this.selectedBrandName_ = ''
      this.determinedProvider = null
    },
    clearSelection () {
      this.resetAll()
      this.$nextTick(() => {
        this.searchingBrand = true
        setTimeout(() => {
          this.$refs.brandsearchinput.focus()
        }, 50)
      })
      this.$v.inputBrandName.$touch()
      this.$v.selectedNetwork_.$touch()
      this.vflowInputFocused('inputBrandName')
      this.vflowInputFocused('selectedNetwork_')

      this.$emit('mnpin-provider-determined', this.determinedProvider)
    },
    takeCommonlyBrandSelection (name) {
      this.isProviderWithPriceVisible = true
      this.resetAll()
      this.applyBrandSelection('')
      if (name !== '' && this.isExistingBrand(name)) {
        this.applyBrandSelection(name)
      }
      this.$v.inputBrandName.$touch()
      this.$v.selectedNetwork_.$touch()
      this.vflowInputFocused('inputBrandName')
      this.vflowInputFocused('selectedNetwork_')
    },
    tryToDetermineProvider () {
      this.determinedProvider = null

      const brand = this.storedMNPProviders.find((e) => e.brandName === this.selectedBrandName)

      if (brand) {
        this.determinedProvider = brand.mnpProvidersWithTariffs[0]
        if (this.lastInputBeforeApplied.length === 4 && `${brand.providerCodes}`.toLowerCase().includes(this.lastInputBeforeApplied.toLowerCase())) {
          brand.mnpProvidersWithTariffs.forEach(bp => {
            if (bp.code.toLowerCase() === this.lastInputBeforeApplied.toLowerCase()) {
              this.determinedProvider = bp
            }
          })
        }

        if (this.withNetworkSelect) {
          brand.mnpProvidersWithTariffs.forEach(bp => {
            if (!this.determinedProvider || this.selectableNetworks.length < 2) {
              this.determinedProvider = bp
            }

            bp.networks.key.forEach(n => {
              if (!this.determinedProvider && n === this.selectedNetwork_) {
                this.determinedProvider = bp
              }
            })
          })
        }
      }

      if (this.determinedProvider && this.active_) {
        this.unportableFound_ = !this.determinedProvider.availableForPorting
        this.providerKey_ = this.determinedProvider.key
        this.providerCode_ = this.determinedProvider.code
        this.providerNetwork_ = this.withNetworkSelect ? this.selectedNetwork_ : this.determinedProvider.networks.key[0]
        this.relatedTariff_ = this.determinedProvider.relatedTariffs[0]
      } else {
        this.resetProviderSelection()
        this.relatedTariff_ = this.defaultNoMnpInTariff
      }

      if (this.determinedProvider && this.determinedProvider.availableForPorting) {
        this.$emit('mnpin-provider-determined', this.determinedProvider)
      }
      this.$v.$touch()

      return this.determinedProvider
    },
    reactOnUserInput () {
      this.isProviderWithPriceVisible = false
      this.isNavigatingInProviders = false
      this.isUserTyping = true
      this.focus = -1
      if (this.focus > this.filteredSortedFlaggedBrandSelectOptions().length) {
        this.focus = 0
      }

      if (this.inputBrandName === '' || !this.determinedProvider) {
        this.unportableFound_ = false
        this.unportableSelected_ = false
        this.selectedBrandName = ''
      }
      if (this.inputBrandName !== '') {
        this.searchingBrand = true
      }

      if (!this.isExistingBrand(this.inputBrandName)) {
        this.resetProviderSelection()
      }
      this.getProviderListLength()
      this.$emit('mnpin-provider-determined', this.determinedProvider)
      this.$forceUpdate()
      this.componentKey++
      this.noResults = false
    },
    itemSelection (item) {
      if (this.isExistingBrand(item)) {
        this.applyBrandSelection(item)
      } else {
        this.applyBrandSelection('')
      }

      if (this.initialized) {
        this.$nextTick(() => {
          this.$nextTick(() => {
            if (this.unportableFound_) {
              this.unportableSelected_ = true
            }
          })
        })
      }

      this.searchingBrand = false
    },
    isExistingBrand (name) {
      return this.brandSelectOptions.some(brand => brand.brandName === name)
    },
    findSelectedBrandFocus () {
      return this.filteredSortedFlaggedBrandSelectOptions().findIndex(
        brand => brand.brandName === this.selectedBrandName
      ) || 0
    },
    findSelectedBrand () {
      this.focus = this.findSelectedBrandFocus()
      this.scrollWhenSelectedProvider()
    },
    scrollWhenSelectedProvider () {
      this.$nextTick(() => {
        const focusedElement = document.querySelector('.focus')
        const optionList = document.querySelector('.option-list')
        if (focusedElement && optionList) {
          optionList.scrollTop = focusedElement.offsetTop
        }
      })
    },
    onFocusSelectField () {
      this.focus = -1
      this.unportableFound_ = false
      this.unportableSelected_ = false
      this.searchingBrand = true
      this.$nextTick(() => {
        this.scrollHandlerOnScroll()
      })
    },
    applyBrandSelection (name) {
      if (this.inputBrandName !== name) {
        this.lastInputBeforeApplied = this.inputBrandName
        if (this.doTracking) {
          const data = {
            micro_conversion_category: 'first provider selected',
            micro_conversion_value: name
          }
          if (typeof window.trackingNS?.track?.tracking === 'function') {
            window.trackingNS.track.tracking('micro conversion', data)
          }
          this.doTracking = false
        }
      }
      this.inputBrandName = name
      this.selectedBrandName = name
      this.selectedBrandName_ = name
      this.searchingBrand = false
      this.focus = 0

      if (this.selectableNetworks.length === 0) {
        this.selectedNetwork_ = ''
      } else {
        if (this.selectableNetworks.length === 1 || !this.couldUseNetworkAsQualifier) {
          this.selectedNetwork_ = this.selectableNetworks[0]
        }
      }

      if (this.selectedNetwork_ !== '' && !this.selectableNetworks.includes(this.selectedNetwork_)) {
        this.selectedNetwork_ = ''
      }

      this.$nextTick(() => {
        this.tryToDetermineProvider()
      })
    },
    onEnterByTab () {
      this.onFocusSelectField()
      this.findSelectedBrand()
    },
    onBlurByTab () {
      this.$nextTick(() => {
        const focusedOption = this.filteredSortedFlaggedBrandSelectOptions()[this.focus]
        if (focusedOption) {
          this.itemSelection(focusedOption.brandName)
        }
      })
    },
    onSelectByReturnKey () {
      this.itemSelection(this.lastFocusedBrand)
      this.searchingBrand = false
      this.$refs.brandsearchinput.blur()
    },
    focusChanged (event) {
      const el = this.$refs[`dropdown${this.$vnode.key}`]
      if (el && el !== event.target && !el.contains(event.target)) {
        this.$nextTick(() => {
          const selectProviderElement = document.getElementById('selectProvider')
          if (selectProviderElement) {
            selectProviderElement.tabIndex = 0
          }
        })
      }
    },
    listItemMouseOver (index) {
      if (!this.scrollHandlerDragging) {
        this.focus = index
      }
    },
    listItemMouseLeave (index) {
      if (!this.scrollHandlerDragging) {
        this.focus = index
      }
    },
    onArrowKeyScroll (event) {
      const elHeight = document.querySelector('.focus')?.offsetHeight || 30
      const y = document.querySelector('.option-list')?.scrollTop || 0
      let scrollTo = y
      const numEl = this.filteredSortedFlaggedBrandSelectOptions().length
      let prevent = false

      switch (event.keyCode) {
        case 33: // Page Up
          this.focus = 0
          scrollTo = 0
          prevent = true
          break
        case 38: // Arrow Up
          this.isNavigatingInProviders = true
          if (this.focus > 0) {
            this.focus--
          }
          if (this.focus === -1) {
            this.focus++
          }
          scrollTo = this.focus * elHeight
          prevent = true
          break
        case 34: // Page Down
          this.focus = numEl - 1
          scrollTo = this.focus * elHeight
          prevent = true
          break
        case 40: // Arrow Down
          this.isNavigatingInProviders = true
          if (this.focus < numEl - 1) {
            this.focus++
          }
          scrollTo = this.focus * elHeight
          prevent = true
          break
      }

      this.lastFocusedBrand = ''
      if (this.filteredSortedFlaggedBrandSelectOptions()[this.focus]) {
        this.lastFocusedBrand = this.filteredSortedFlaggedBrandSelectOptions()[this.focus].brandName
      }

      if (scrollTo < 0) {
        scrollTo = 0
      }

      if (scrollTo > (numEl - 1) * elHeight) {
        scrollTo = (numEl - 1) * elHeight
      }

      document.querySelector('.option-list').scrollTop = scrollTo

      if (prevent) {
        event.preventDefault()
      }
    },
    documentClick (e) {
      if (this.searchingBrand) {
        const el = this.$refs[`dropdown${this.$vnode.key}`]
        if (el && el !== e.target && !el.contains(e.target) && e.target.id !== 'brand-search-clear-input') {
          this.applyBrandSelection(this.selectedBrandName)
        }
      }
    },
    grabScrollEvent (e) {
      e.stopPropagation()
    },
    calculateScrollRatio () {
      const sh = this.$refs.dropdownListContainer.scrollHeight
      const ch = this.$refs.dropdownListContainer.clientHeight
      return ch / sh
    },
    scrollHandlerOnDragStart (e) {
      e.preventDefault()
      this.scrollHandlerDragging = true
      this.scrollHandlerDragStartPos = this.$refs.scrollHandle.offsetTop
      this.scrollHandlerDragLastPageY = e.pageY
    },
    scrollHandlerOnDragCatch (e) {
      if (this.scrollHandlerDragging) {
        e.preventDefault()
      }
    },
    scrollHandlerOnDrag (e) {
      e.preventDefault()
      if (this.scrollHandlerDragging) {
        const sr = this.calculateScrollRatio()
        const ch = this.$refs.dropdownListContainer.clientHeight
        const delta = e.pageY - this.scrollHandlerDragLastPageY
        this.scrollHandlerDragLastPageY = e.pageY
        let cp = (this.scrollHandlerDragStartPos += delta)

        if (cp < 10) {
          cp = 10
        }
        if (cp > ch - 30) {
          cp = ch - 30
        }

        const raf = window.requestAnimationFrame || window.setImmediate || (c => setTimeout(c, 0))
        raf(() => {
          this.$refs.dropdownListContainer.scrollTop += delta / sr
          this.$refs.scrollHandle.style.top = `${cp}px`
        })
      }
    },
    scrollHandlerOnDragEnd () {
      this.scrollHandlerDragging = false
    },
    scrollHandlerOnScroll () {
      if (!this.scrollHandlerDragging && this.$refs.dropdownListContainer) {
        const ch = this.$refs.dropdownListContainer.clientHeight
        const st = this.$refs.dropdownListContainer.scrollTop
        const sr = this.calculateScrollRatio()
        const raf = window.requestAnimationFrame || window.setImmediate || (c => setTimeout(c, 0))

        if (sr < 1) {
          let ht = Math.floor(st * sr)
          if (ht < 10) {
            ht = 10
          }
          if (ht > ch - 30) {
            ht = ch - 30
          }

          raf(() => {
            if (this.$refs.scrollHandle) {
              this.$refs.scrollHandle.style.display = 'block'
              this.$refs.scrollHandle.style.top = `${ht}px`
            }
          })
        } else {
          raf(() => {
            if (this.$refs.scrollHandle) {
              this.$refs.scrollHandle.style.display = 'none'
            }
          })
        }
      }
    },
    filteredSortedFlaggedBrandSelectOptions () {
      const rearrangedOptions = []

      this.filteredBrandSelectOptions().forEach(o => {
        rearrangedOptions.push({
          ...o,
          matchByBrandName: o.brandName.toLowerCase().indexOf(this.inputBrandName.toLowerCase()) === 0,
          matchedByCode: (this.inputBrandName.length === 4 && o.providerCodes.toLowerCase().includes(this.inputBrandName.toLowerCase())) ? this.inputBrandName.toUpperCase() : null
        })
      })

      rearrangedOptions.sort((a, b) => a.matchByBrandName === b.matchByBrandName ? 0 : a.matchByBrandName ? -1 : 1)

      if (this.inputBrandName !== '') {
        return rearrangedOptions
      }

      const fullList = []

      rearrangedOptions.forEach(item => {
        if (this.quickSelectionBrandIdent_().includes(item.brandName)) {
          item.frequency = 'high'
          fullList.push(item)
        }
      })

      rearrangedOptions.forEach(item => {
        if (!this.quickSelectionBrandIdent_().includes(item.brandName)) {
          item.frequency = 'low'
          fullList.push(item)
        }
      })

      return fullList
    },
    quickSelectionBrandIdent_ () {
      return this.quickSelectionBrand.split(',').map(item => item.trim())
    },
    findLastHighBrand (brand) {
      const list = this.filteredSortedFlaggedBrandSelectOptions().filter(item => item.frequency === 'high')
      const last = list.pop()
      return last?.brandName === brand.brandName
    },
    filteredBrandSelectOptions () {
      return this.brandSelectOptions.filter(brand => {
        return (
          brand.brandName.toLowerCase().indexOf(this.inputBrandName.toLowerCase()) >= 0 ||
          (this.inputBrandName.length === 4 && brand.providerCodes.toLowerCase().includes(this.inputBrandName.toLowerCase()))
        )
      })
    },
    trackAndShowBrandSearchInfoModal () {
      this.showBrandSearchInfoModal = true
      const data = {
        information_action: 'reveal',
        information_name: 'mnp provider search info modal',
        information_ui_type: 'overlay',
        information_trigger: 'icon'
      }
      if (typeof window.trackingNS?.track?.tracking === 'function') {
        window.trackingNS.track.tracking('information', data)
      }
    },
    findProviderTariff (brand) {
      let tariff = brand.mnpProvidersWithTariffs[0]?.relatedTariffs[0]
      if (this.inputBrandName.length === 4) {
        brand.mnpProvidersWithTariffs.forEach(bp => {
          if (bp.code.toLowerCase() === this.inputBrandName.toLowerCase()) {
            tariff = bp.relatedTariffs[0]
          }
        })
      }
      return tariff
    },
    tariffBasicFee (brand) {
      return brand.tariff?.basicFee || null
    },
    tariffPromoPrice (brand) {
      return brand.tariff?.promoPrices?.promoPrice || null
    },
    hasTariffPromoPrice (brand) {
      const promoPrice = this.tariffPromoPrice(brand)
      return promoPrice > 0 && promoPrice !== this.tariffBasicFee(brand)
    },
    formattedPriceWithOption (brand) {
      let price = this.tariffBasicFee(brand)
      price = this.brandPriceWithOption(price)
      return this.formatPrice(price)
    },
    brandPriceWithOption (price) {
      if (price !== null && this.targetTariffOptions.length) {
        price += this.targetTariffOptions[0].price
      }
      return price
    },
    formattedPromoPriceWithOption (brand) {
      const price = this.tariffPromoPrice(brand) ? this.tariffPromoPrice(brand) : this.tariffBasicFee(brand)
      return this.formatPrice(price)
    },
    formatPrice (price) {
      if (price) {
        return this.price(price)
      } else {
        return ''
      }
    }
  },
  computed: {
    placeholderForInput () {
      if (this.isNavigatingInProviders || this.isUserTyping || this.inputBrandName.length > 0) {
        return ''
      } else { return this.$slots.txtPlaceholderSearchField[0].text }
    },
    ariaLiveForInput () {
      if (this.isNavigatingInProviders) {
        return 'polite'
      } else { return 'off' }
    },
    ariaLabelForInput () {
      return this.$slots.txtSearchFieldAltText[0].text
    },
    isLoadingProvidersError () {
      return !this.embedded && (this.storedMNProvidersLoadedStatus === 'ERROR' || this.storedMNProvidersLoadedStatus === 'INVALID')
    },
    storedMNPProviders () {
      return this.$store.getters[`checkoutv2/${this.process}/_mnpData/providerList`]
    },
    storedMNProvidersLoadedStatus () {
      return this.$store.getters[`checkoutv2/${this.process}/_mnpData/providerListLoadingStatus`]
    },
    targetTariffOptions () {
      return this.$store.getters[`checkoutv2/${this.process}/_cart/targetTariffoptions`]
    },
    isKwkTariff () {
      return this.$store.getters[`checkoutv2/${this.process}/_cart/kwkToken`] || this.$store.getters[`checkoutv2/${this.process}/_cart/targetTariff`].tariffId === '162'
    },
    showPrice: function () {
      return !this.isKwkTariff
    },
    featurePromotion () {
      return this.showFeaturePromotion || this.showFeaturePromotionProviderOnly
    },
    validBrandSelected () {
      return this.isExistingBrand(this.selectedBrandName)
    },
    brandSelectOptions () {
      const brands = []
      this.storedMNPProviders.forEach(brand => {
        brands.push({
          brandName: brand.brandName,
          providerCodes: '',
          tariff: this.findProviderTariff(brand)
        })

        brand.mnpProvidersWithTariffs.forEach(bp => {
          brands[brands.length - 1].providerCodes += ` ${bp.code}`
        })
      })

      return brands.sort((a, b) => a.brandName.toLowerCase().localeCompare(b.brandName.toLowerCase()))
    },
    couldUseNetworkAsQualifier () {
      const providerCodes = []
      const firstProviderByNetwork = []
      if (this.isExistingBrand(this.selectedBrandName)) {
        const brand = this.storedMNPProviders.find(e => e.brandName === this.selectedBrandName)

        if (this.lastInputBeforeApplied.length === 4 && brand.providerCodes.toLowerCase().includes(this.lastInputBeforeApplied.toLowerCase())) {
          return false
        }

        if (brand) {
          brand.mnpProvidersWithTariffs.forEach(bp => {
            providerCodes.push(bp.code)
            bp.networks.key.forEach(n => {
              if (!firstProviderByNetwork[n]) {
                firstProviderByNetwork[n] = bp.code
              }
            })
          })
        }
      }

      let providerChangedWithNetwork = false
      if (providerCodes.length > 1) {
        let lastFoundProvider = null
        for (const providerCode of Object.values(firstProviderByNetwork)) {
          if (lastFoundProvider !== null && lastFoundProvider !== providerCode) {
            providerChangedWithNetwork = true
          }
          lastFoundProvider = providerCode
        }
      }

      return providerCodes.length > 1 && providerChangedWithNetwork
    },
    selectableNetworks () {
      const networks = []
      if (this.isExistingBrand(this.selectedBrandName)) {
        const brand = this.storedMNPProviders.find(e => e.brandName === this.selectedBrandName)

        if (brand) {
          brand.mnpProvidersWithTariffs.forEach(bp => {
            if (bp.availableForPorting) {
              bp.networks.key.forEach(n => {
                if (!networks.includes(n)) {
                  networks.push(n)
                }
              })
            }
          })
        }
      }

      return networks
    },
    selectedBrandNameWithPrice () {
      const brand = this.filteredSortedFlaggedBrandSelectOptions().find(brand => brand.brandName === this.inputBrandName)
      if (brand) {
        return brand.brandName + ' ' + this.formattedPriceWithOption(brand)
      }
      return ''
    }
  },
  validations () {
    return {
      inputBrandName: {
        required,
        found (v) {
          return (
            this.selectedBrandName_ !== '' &&
            this.isExistingBrand(this.selectedBrandName_) &&
            this.determinedProvider !== null &&
            !this.unportableFound_
          )
        }
      },
      selectedNetwork_: {
        found (v) {
          if (this.selectedBrandName_ !== '' && this.withNetworkSelect && this.selectableNetworks.length > 1) {
            return v !== ''
          }
          return true
        }
      }
    }
  }
}
</script>
